module.exports = __webpack_public_path__ + "static/img/V3-1.acff46a.png";


//////////////////
// WEBPACK FOOTER
// ./static/langPack/20200000/V3-1.png
// module id = z0sL
// module chunks = 1